import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      grow: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, {
          href: "#main",
          value: "main"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" Edition ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_tab, {
          href: "#scope",
          value: "scope"
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" Périmètre ")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_tabs_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "main" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { flat: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("Parametrage")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_subtitle, null, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Paramétrez votre extension")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                      modelValue: _ctx.isValidForm,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isValidForm) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          label: "Nom de l'extension",
                          modelValue: _ctx.nameSync,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nameSync) = $event)),
                          outlined: "",
                          readonly: _ctx.readonly,
                          rules: [(v) => !!v || 'Le nom de l\'extension est requis'],
                          density: "compact",
                          class: "pb-4"
                        }, null, 8, ["modelValue", "readonly", "rules"]),
                        _createVNode(_component_v_text_field_filled, {
                          label: "Url",
                          placeholder: "https://",
                          modelValue: _ctx.urlSync,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.urlSync) = $event)),
                          outlined: "",
                          readonly: _ctx.readonly,
                          rules: [
                                    (v) => !!v || 'L\'url est requise',
                                    // (v) => (v && v.match(this.urlRegex)) || 'L\'url doit être valide',
                                ],
                          density: "compact",
                          class: "pb-4"
                        }, null, 8, ["modelValue", "readonly", "rules"]),
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_v_select_filled, {
                            outlined: "",
                            class: "mr-1",
                            label: "Type",
                            modelValue: _ctx.typeSync,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.typeSync) = $event)),
                            items: _ctx.extensionTypes,
                            readonly: _ctx.readonly,
                            rules: [(v) => !!v || 'Le type est requise'],
                            density: "compact"
                          }, null, 8, ["modelValue", "items", "readonly", "rules"]),
                          _createVNode(_component_v_select_filled, {
                            outlined: "",
                            class: "ml-1",
                            label: "Page d'affichage",
                            modelValue: _ctx.displayInSync,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.displayInSync) = $event)),
                            items: _ctx.extensionDisplayIn,
                            readonly: _ctx.readonly,
                            rules: [(v) => !!v || 'La page d\'affichage est requise'],
                            density: "compact"
                          }, null, 8, ["modelValue", "items", "readonly", "rules"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "scope" }, {
          default: _withCtx(() => [
            _createVNode(_component_ScopeManager, {
              modelValue: _ctx.scopeSync,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scopeSync) = $event)),
              id: _ctx.scopeId,
              "onUpdate:id": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scopeId) = $event)),
              name: _ctx.scopeName,
              "onUpdate:name": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scopeName) = $event)),
              readonly: _ctx.readonly
            }, null, 8, ["modelValue", "id", "name", "readonly"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}